import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "@/views/Home.vue";
import store from "@/store";
import { Message } from "element-ui";
import { parseTime } from "@/utils";
Vue.use(VueRouter);

const originalpush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalpush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    redirect: "/app",
  },
  {
    path: '/app',
    name: 'App',
    component: () => import("@/App.vue")
  },
];

const router = new VueRouter({
  routes,
});

const getDefaultDateFun = async (to, next) => {
  let params = {};
  //   params.plat = store.state.user.plants
  //     ? store.state.user.plants.join(",")
  //     : "";
  await getDefaultDate(params).then((res) => {
    if (res.status == "ok") {
      store.dispatch("user/changeStartMonth", res.result.start);
      store.dispatch("user/changeEndMonth", res.result.end);
      localStorage.setItem("defaultStartMonth", res.result.start);
      localStorage.setItem("defaultEndMonth", res.result.end);
      router.push({
        name: to.name,
        query: {
          start: parseTime(store.state.user.startMonth, "{y}-{m}"),
          end: parseTime(store.state.user.endMonth, "{y}-{m}"),
        },
      });
      next();
    }
  });
  //   } else {
  //     return;
  //   }
};

router.beforeEach(async (to, from, next) => {
  next();
});

export default router;
